"use client";

import { useTranslations } from "next-intl";

export default function GenreCalendarError({ reset }: { reset: () => void }) {
  const t = useTranslations("GenreCalendar");
  return (
    <main className="mx-auto min-h-[60vh] max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="font-mono text-2xl font-bold text-white">{t("errorTitle")}</h1>
      <p className="mt-4 text-sm text-neutral-300">{t("errorBody")}</p>
      <button type="button" onClick={reset} className="mt-6 min-h-11 cursor-pointer rounded-md bg-acid px-4 py-2 font-mono text-sm text-black hover:brightness-110 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-acid">{t("tryAgain")}</button>
    </main>
  );
}
